module.exports = __webpack_public_path__ + "static/media/thumbsup.4b6462da.png";